import { type ConsentedApp } from '../types';

export const isAppConsentedLocally = (appId: string, accountId?: string): boolean =>
	!!(window['__consentedApps'] as ConsentedApp)?.[`${appId}:${accountId}`];

export const setAppConsentLocal = (appId: string, accountId?: string): void => {
	window.__consentedApps = window.__consentedApps || {};
	window.__consentedApps[`${appId}:${accountId}`] = true;
};
